import * as z from "zod";
import { enrollmentResultBase } from "./enrollment-result";
import { resolveEnrollProfileSchema } from "./get-disputely-resolve-prefill";

// Submit a RESOLVE enrollment with the merchant-confirmed profile (§5.5.3).
// `status` is our submission outcome; `error` carries the validation gap or
// Disputely's RFC-7807 detail on failure.
export const enrollDisputelyResolve = {
  name: "enrollDisputelyResolve" as const,
  input: z.object({ profile: resolveEnrollProfileSchema }),
  output: enrollmentResultBase.extend({
    status: z.enum(["enrolled", "failed"]),
  }),
};
